module.exports = __webpack_public_path__ + "img/25.778a260a.jpg";